<template>
  <v-card
    outlined
    :class="[
      'docs-section-card pa-4 mb-4',
      { 'docs-section-card--dark': isDarkDocsTheme },
    ]"
  >
    <div
      v-if="eyebrow"
      class="caption text-uppercase font-weight-bold mb-2 docs-section-eyebrow"
    >
      {{ eyebrow }}
    </div>

    <div class="d-flex align-start mb-2">
      <font-awesome-icon
        v-if="icon"
        :icon="icon"
        size="sm"
        class="mr-2 mt-1 docs-section-icon"
      />

      <div>
        <h2 class="subtitle-1 font-weight-bold mb-1 docs-section-title">
          {{ title }}
        </h2>

        <p
          v-if="description"
          class="body-2 mb-0 docs-section-description"
        >
          {{ description }}
        </p>
      </div>
    </div>

    <div
      v-if="$slots.default"
      class="docs-section-body mt-3"
    >
      <slot />
    </div>

    <div
      v-if="$slots.actions"
      class="mt-3"
    >
      <slot name="actions" />
    </div>
  </v-card>
</template>

<script>
import themeClasses from '@/mixins/themeClasses'

export default {
  name: 'DocsSectionCard',
  mixins: [themeClasses],
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    eyebrow: {
      type: String,
      default: '',
    },
    icon: {
      type: Array,
      default: null,
    },
  },
  computed: {
    isDarkDocsTheme() {
      return this.isDarkThemeContext()
    },
  },
}
</script>

<style scoped lang="scss">
.docs-section-card {
  border-radius: 10px;
  border-color: rgba(9, 44, 76, 0.12) !important;
}

.docs-section-eyebrow {
  color: #00aed6;
  letter-spacing: 0.8px;
}

.docs-section-title {
  color: #0d2f4b;
}

.docs-section-icon {
  color: #00aed6;
}

.docs-section-description {
  color: rgba(13, 47, 75, 0.74);
}

.docs-section-card--dark {
  background-color: rgba(8, 23, 37, 0.72);
  border-color: rgba(150, 215, 255, 0.28) !important;
}

.docs-section-card--dark .docs-section-eyebrow {
  color: rgba(119, 224, 255, 0.98);
}

.docs-section-card--dark .docs-section-title {
  color: #eef7ff;
}

.docs-section-card--dark .docs-section-icon {
  color: rgba(132, 227, 255, 0.95);
}

.docs-section-card--dark .docs-section-description {
  color: rgba(227, 241, 255, 0.88);
}

.docs-section-card--dark .docs-section-body {
  color: rgba(232, 244, 255, 0.9);
}
</style>
